module.exports = __webpack_public_path__ + "img/check-mark.a65eb2c2.svg";